import React from 'react';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { Building2, Shield, Award } from 'lucide-react';
import ConnectionStatus from '../ConnectionStatus';

const Header = () => {
  return (
    <Card className="p-6 mb-6 bg-gradient-to-r from-teal-600 via-cyan-600 to-blue-600 border-0 shadow-xl">
      <div className="flex items-center justify-between">
        {/* Logo and Title Section */}
        <div className="flex items-center space-x-4">
          {/* UMC Logo - Actual Logo */}
          <div className="flex items-center justify-center w-20 h-20 bg-white rounded-full shadow-lg p-2">
            <img 
              src="/umc-logo.png" 
              alt="Ulhasnagar Municipal Corporation Logo" 
              className="w-full h-full object-contain"
              onError={(e) => {
                // Fallback to enhanced placeholder if image fails to load
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            {/* Fallback Enhanced Placeholder */}
            <div className="w-full h-full bg-gradient-to-br from-teal-600 to-blue-600 rounded-full items-center justify-center relative overflow-hidden" style={{display: 'none'}}>
              <div className="text-center">
                <div className="text-white font-bold text-lg leading-none">UMC</div>
                <div className="text-white text-xs font-medium leading-none mt-1">उमाश्रे</div>
              </div>
              <div className="absolute top-1 right-1 w-2 h-2 bg-white/30 rounded-full"></div>
              <div className="absolute bottom-1 left-1 w-1 h-1 bg-white/40 rounded-full"></div>
            </div>
          </div>
          
          {/* Title and Subtitle */}
          <div>
            <h1 className="text-xl font-bold text-white mb-1">
              Ulhasnagar Municipal Corporation
            </h1>
            <h2 className="text-2xl font-bold text-white mb-1">
              IWMS - Project Monitoring Dashboard
            </h2>
            <p className="text-teal-100 text-sm font-medium">
              Intelligent Works Management System
            </p>
          </div>
        </div>

        {/* Status Indicators */}
        <div className="flex items-center space-x-4">
          <div className="text-right">
            <div className="flex items-center space-x-2 mb-2">
              <Shield className="h-5 w-5 text-white" />
              <span className="text-white font-semibold">Data Source Status</span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="flex items-center space-x-2">
                {/* MySQL Connection Status Indicator */}
                <ConnectionStatus />
                <Badge className="bg-blue-500 text-white border-0 hover:bg-blue-500">
                  <Award className="h-3 w-3 mr-1" />
                  AI Enabled
                </Badge>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default Header;